/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { CommandDto } from '../model/commandDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class CommandsCustomerService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @param userId 
     * @param commandDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public add(userId: number, commandDto: CommandDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CommandDto>;
    public add(userId: number, commandDto: CommandDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CommandDto>>;
    public add(userId: number, commandDto: CommandDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CommandDto>>;
    public add(userId: number, commandDto: CommandDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling add.');
        }
        if (commandDto === null || commandDto === undefined) {
            throw new Error('Required parameter commandDto was null or undefined when calling add.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>userId, 'userId');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/commands`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CommandDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: commandDto,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param userId 
     * @param commandDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addRemoteCommand(userId: number, commandDto: CommandDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CommandDto>;
    public addRemoteCommand(userId: number, commandDto: CommandDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CommandDto>>;
    public addRemoteCommand(userId: number, commandDto: CommandDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CommandDto>>;
    public addRemoteCommand(userId: number, commandDto: CommandDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling addRemoteCommand.');
        }
        if (commandDto === null || commandDto === undefined) {
            throw new Error('Required parameter commandDto was null or undefined when calling addRemoteCommand.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>userId, 'userId');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/commands/remote`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CommandDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: commandDto,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param page 
     * @param count 
     * @param orderBy 
     * @param orderDirection 
     * @param deviceClassWithOwnIdPool 
     * @param requestBody 
     * @param commandStateFilter 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public get(page: number, count: number, orderBy: string, orderDirection: string, deviceClassWithOwnIdPool: 'COLLAR' | 'EXTERNAL_SENSOR' | 'CAMERA' | 'TT4_SENSOR' | 'CONFIGURATION_DEVICE' | 'DROP_OFF' | 'TRAP_TRANSMITTER' | 'DATA_LOGGER', requestBody: Array<number>, commandStateFilter?: Array<'CREATED' | 'SENT_TO_SERVER' | 'SENT_TO_DEVICE' | 'FAILED_SENDING_TO_SERVER' | 'FAILED_SENDING_TO_DEVICE' | 'FAILED_ON_DEVICE' | 'FAILED_UNSPECIFIED' | 'ACKNOWLEDGED' | 'CANCELED' | 'FAILED_EXPIRED'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<CommandDto>>;
    public get(page: number, count: number, orderBy: string, orderDirection: string, deviceClassWithOwnIdPool: 'COLLAR' | 'EXTERNAL_SENSOR' | 'CAMERA' | 'TT4_SENSOR' | 'CONFIGURATION_DEVICE' | 'DROP_OFF' | 'TRAP_TRANSMITTER' | 'DATA_LOGGER', requestBody: Array<number>, commandStateFilter?: Array<'CREATED' | 'SENT_TO_SERVER' | 'SENT_TO_DEVICE' | 'FAILED_SENDING_TO_SERVER' | 'FAILED_SENDING_TO_DEVICE' | 'FAILED_ON_DEVICE' | 'FAILED_UNSPECIFIED' | 'ACKNOWLEDGED' | 'CANCELED' | 'FAILED_EXPIRED'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<CommandDto>>>;
    public get(page: number, count: number, orderBy: string, orderDirection: string, deviceClassWithOwnIdPool: 'COLLAR' | 'EXTERNAL_SENSOR' | 'CAMERA' | 'TT4_SENSOR' | 'CONFIGURATION_DEVICE' | 'DROP_OFF' | 'TRAP_TRANSMITTER' | 'DATA_LOGGER', requestBody: Array<number>, commandStateFilter?: Array<'CREATED' | 'SENT_TO_SERVER' | 'SENT_TO_DEVICE' | 'FAILED_SENDING_TO_SERVER' | 'FAILED_SENDING_TO_DEVICE' | 'FAILED_ON_DEVICE' | 'FAILED_UNSPECIFIED' | 'ACKNOWLEDGED' | 'CANCELED' | 'FAILED_EXPIRED'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<CommandDto>>>;
    public get(page: number, count: number, orderBy: string, orderDirection: string, deviceClassWithOwnIdPool: 'COLLAR' | 'EXTERNAL_SENSOR' | 'CAMERA' | 'TT4_SENSOR' | 'CONFIGURATION_DEVICE' | 'DROP_OFF' | 'TRAP_TRANSMITTER' | 'DATA_LOGGER', requestBody: Array<number>, commandStateFilter?: Array<'CREATED' | 'SENT_TO_SERVER' | 'SENT_TO_DEVICE' | 'FAILED_SENDING_TO_SERVER' | 'FAILED_SENDING_TO_DEVICE' | 'FAILED_ON_DEVICE' | 'FAILED_UNSPECIFIED' | 'ACKNOWLEDGED' | 'CANCELED' | 'FAILED_EXPIRED'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling get.');
        }
        if (count === null || count === undefined) {
            throw new Error('Required parameter count was null or undefined when calling get.');
        }
        if (orderBy === null || orderBy === undefined) {
            throw new Error('Required parameter orderBy was null or undefined when calling get.');
        }
        if (orderDirection === null || orderDirection === undefined) {
            throw new Error('Required parameter orderDirection was null or undefined when calling get.');
        }
        if (deviceClassWithOwnIdPool === null || deviceClassWithOwnIdPool === undefined) {
            throw new Error('Required parameter deviceClassWithOwnIdPool was null or undefined when calling get.');
        }
        if (requestBody === null || requestBody === undefined) {
            throw new Error('Required parameter requestBody was null or undefined when calling get.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>page, 'page');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>count, 'count');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orderBy, 'orderBy');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orderDirection, 'orderDirection');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deviceClassWithOwnIdPool, 'deviceClassWithOwnIdPool');
        if (commandStateFilter) {
            commandStateFilter.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'commandStateFilter');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/commands/get-commands`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<CommandDto>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: requestBody,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getById(id: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CommandDto>;
    public getById(id: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CommandDto>>;
    public getById(id: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CommandDto>>;
    public getById(id: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getById.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/commands/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CommandDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param deviceClassWithOwnIdPool 
     * @param requestBody 
     * @param commandStateFilter 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCount(deviceClassWithOwnIdPool: 'COLLAR' | 'EXTERNAL_SENSOR' | 'CAMERA' | 'TT4_SENSOR' | 'CONFIGURATION_DEVICE' | 'DROP_OFF' | 'TRAP_TRANSMITTER' | 'DATA_LOGGER', requestBody: Array<number>, commandStateFilter?: Array<'CREATED' | 'SENT_TO_SERVER' | 'SENT_TO_DEVICE' | 'FAILED_SENDING_TO_SERVER' | 'FAILED_SENDING_TO_DEVICE' | 'FAILED_ON_DEVICE' | 'FAILED_UNSPECIFIED' | 'ACKNOWLEDGED' | 'CANCELED' | 'FAILED_EXPIRED'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<number>;
    public getCount(deviceClassWithOwnIdPool: 'COLLAR' | 'EXTERNAL_SENSOR' | 'CAMERA' | 'TT4_SENSOR' | 'CONFIGURATION_DEVICE' | 'DROP_OFF' | 'TRAP_TRANSMITTER' | 'DATA_LOGGER', requestBody: Array<number>, commandStateFilter?: Array<'CREATED' | 'SENT_TO_SERVER' | 'SENT_TO_DEVICE' | 'FAILED_SENDING_TO_SERVER' | 'FAILED_SENDING_TO_DEVICE' | 'FAILED_ON_DEVICE' | 'FAILED_UNSPECIFIED' | 'ACKNOWLEDGED' | 'CANCELED' | 'FAILED_EXPIRED'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<number>>;
    public getCount(deviceClassWithOwnIdPool: 'COLLAR' | 'EXTERNAL_SENSOR' | 'CAMERA' | 'TT4_SENSOR' | 'CONFIGURATION_DEVICE' | 'DROP_OFF' | 'TRAP_TRANSMITTER' | 'DATA_LOGGER', requestBody: Array<number>, commandStateFilter?: Array<'CREATED' | 'SENT_TO_SERVER' | 'SENT_TO_DEVICE' | 'FAILED_SENDING_TO_SERVER' | 'FAILED_SENDING_TO_DEVICE' | 'FAILED_ON_DEVICE' | 'FAILED_UNSPECIFIED' | 'ACKNOWLEDGED' | 'CANCELED' | 'FAILED_EXPIRED'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<number>>;
    public getCount(deviceClassWithOwnIdPool: 'COLLAR' | 'EXTERNAL_SENSOR' | 'CAMERA' | 'TT4_SENSOR' | 'CONFIGURATION_DEVICE' | 'DROP_OFF' | 'TRAP_TRANSMITTER' | 'DATA_LOGGER', requestBody: Array<number>, commandStateFilter?: Array<'CREATED' | 'SENT_TO_SERVER' | 'SENT_TO_DEVICE' | 'FAILED_SENDING_TO_SERVER' | 'FAILED_SENDING_TO_DEVICE' | 'FAILED_ON_DEVICE' | 'FAILED_UNSPECIFIED' | 'ACKNOWLEDGED' | 'CANCELED' | 'FAILED_EXPIRED'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deviceClassWithOwnIdPool === null || deviceClassWithOwnIdPool === undefined) {
            throw new Error('Required parameter deviceClassWithOwnIdPool was null or undefined when calling getCount.');
        }
        if (requestBody === null || requestBody === undefined) {
            throw new Error('Required parameter requestBody was null or undefined when calling getCount.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deviceClassWithOwnIdPool, 'deviceClassWithOwnIdPool');
        if (commandStateFilter) {
            commandStateFilter.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'commandStateFilter');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/commands/get-commands-count`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<number>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: requestBody,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param commandDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public validateRemoteCommand(commandDto: CommandDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<number>;
    public validateRemoteCommand(commandDto: CommandDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<number>>;
    public validateRemoteCommand(commandDto: CommandDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<number>>;
    public validateRemoteCommand(commandDto: CommandDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (commandDto === null || commandDto === undefined) {
            throw new Error('Required parameter commandDto was null or undefined when calling validateRemoteCommand.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/commands/remote/validate`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<number>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: commandDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
